import { render, staticRenderFns } from "./PieChartCustomLegend.vue?vue&type=template&id=002fcdfe&scoped=true"
import script from "./PieChartCustomLegend.vue?vue&type=script&lang=js"
export * from "./PieChartCustomLegend.vue?vue&type=script&lang=js"
import style0 from "./PieChartCustomLegend.vue?vue&type=style&index=0&id=002fcdfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002fcdfe",
  null
  
)

export default component.exports